export default __webpack_public_path__ + "static/SRUS P147 - Product Specifications & Technical Data-d11731cd23639b726e211dcfc8875e03.pdf";